module.exports = __webpack_public_path__ + "img/lexicon.67ce7c79.svg";